import { PageMeta } from "@/components/common/PageMeta";
import { ScrollSection } from "@/components/main-page/ScrollSection";
import { IRSubNav } from "@/components/ir/IRSubNav";
import { NDAForm } from "@/components/ir/NDAForm";

export function NDAPage() {
  return (
    <>
      <PageMeta
        title="NDA Agreement | COSX Dataroom"
        description="Review and sign a non-disclosure agreement to access confidential investor documents in the COSX dataroom."
        path="/ir/dataroom/nda"
        noindex
      />

      <div className="relative z-10 pt-[var(--topnav-height)] px-8">
        <div className="max-w-6xl mx-auto w-full pt-8">
          <IRSubNav />
        </div>
      </div>

      <ScrollSection id="nda" title="Dataroom Access" subtitle="Please review and sign the NDA below to access confidential investor documents." compact>
        <NDAForm />
      </ScrollSection>
    </>
  );
}
